// extracted by mini-css-extract-plugin
export default {"form-wrapper":"ModalPrePublishUrl_form-wrapper__o41DL","input-wrapper":"ModalPrePublishUrl_input-wrapper__hHeoR","select-wrapper":"ModalPrePublishUrl_select-wrapper__5phl9"};